import { type PropsWithChildren } from "react";
import { Card as ReshapedCard } from "reshaped";

import { type Action, getActionAnchorProps, getActionClickableProps } from "../action/Action";
import Text from "./Text";

type CardProps = PropsWithChildren<{
    title?: string;
    action?: Action;
}>;

export default function Card(props: CardProps) {
    const { title, action, children } = props;

    const anchorProps = action ? getActionAnchorProps(action) : {};
    const clickableProps = action ? getActionClickableProps(action) : {};
    return (
        <ReshapedCard {...anchorProps} {...clickableProps}>
            {title ? <Text variant="subheading">{title}</Text> : null}
            {children}
        </ReshapedCard>
    );
}
